<template>
  <div class="header-panel">
    <div class="header-panel__breadcrumb">
      <back-arrow :page-name="backPageName" v-if="backPageName"></back-arrow>
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link :to="homeLink"> Главная </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>Мои проекты</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="header-panel__search">
      <a-col :span="24" class="form-step__fields">
        <a-form-item name="role" class="header-panel__search-wrapper">
          <a-select
            id="role"
            placeholder="Роль"
            v-model:value="currentRole"
            :options="roles"
            @change="onRoleChange"
          />
        </a-form-item>
      </a-col>
      <!--      <input-->
      <!--        type="text"-->
      <!--        placeholder="Ищите документы, проекты, людей или другое"-->
      <!--      />-->
      <!--      <img src="./assets/search.svg" alt="" />-->
    </div>
    <div class="header-panel__profile">
      <DropdownMenu :name="name" />
      <div class="header-panel__profile-email">{{ email }}</div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import { useApi } from '@/api/use-api';
  import DropdownMenu from './components/dropdown-menu/DropdownMenu';
  import BackArrow from '@/components/navigation/BackArrow.vue';
  import { useRoute, useRouter } from 'vue-router';
  import { getDefaultRouteByRole } from '@/router';
  import {
    USER_ROLE_ADMINISTRATOR,
    USER_ROLE_LEADER,
    USER_ROLE_MODERATOR,
  } from '@/api/models/UserRole';

  const api = useApi();
  const email = ref('');
  const name = ref('');
  const homeLink = ref('');
  const roles = ref([]);
  const currentRole = ref(null);
  const route = useRoute();
  const router = useRouter();

  defineProps({
    backPageName: {
      type: String,
      default: '',
    },
  });

  onMounted(() => {
    getUser();
    getRoles();
  });

  async function getUser() {
    try {
      const response = await api.user.index();
      email.value = response.email;
      name.value = response.name;
    } catch (error) {
      console.error('error', error);
    }
  }

  async function getRoles() {
    try {
      const response = await api.user.roles();
      // TODO (DM) - add roles and profile to vuex
      roles.value = response.roles.filter((item) => item.value !== 'root');
      currentRole.value =
        route.meta.role ?? localStorage.getItem('currentRole');
    } catch (error) {
      console.error('error', error);
    }
  }

  async function onRoleChange() {
    localStorage.setItem('currentRole', currentRole.value);
    const defaultRoute = getDefaultRouteByRole(currentRole.value);
    homeLink.value = defaultRoute.path;

    switch (currentRole.value) {
      case USER_ROLE_ADMINISTRATOR:
        await forwardForAdmin();
        break;
      case USER_ROLE_LEADER:
        await forwardForLeader();
        break;
      case USER_ROLE_MODERATOR:
        await forwardForModerator();
        break;
      default:
        await router.push(defaultRoute);
    }
  }

  const forwardForAdmin = async () => {
    try {
      const response = await api.request.count(USER_ROLE_ADMINISTRATOR);

      if (response.count > 0) {
        await router.push(`/${currentRole.value}/requests#new`);
      } else {
        await router.push(`/${currentRole.value}/requests#inwork`);
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  const forwardForLeader = async () => {
    try {
      const response = await api.request.count(USER_ROLE_LEADER);

      if (response.count > 0) {
        await router.push(`/${currentRole.value}/requests`);
      } else {
        await router.push(`/${currentRole.value}/projects#inwork`);
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  const forwardForModerator = async () => {
    try {
      const response = await api.request.count(USER_ROLE_MODERATOR);

      if (response.count > 0) {
        await router.push(`/${currentRole.value}/requests#new`);
      } else {
        await router.push(`/${currentRole.value}/requests#archive`);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
  @use 'HeaderPartnerAccount.scss';
</style>
